import { render, staticRenderFns } from "./fvSlide.vue?vue&type=template&id=65b85386&lang=pug&"
var script = {}
import style0 from "./fvSlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvSlide.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvSlide.vue
// module id = 167
// module chunks = 0 1